import { Option, Result } from '@sapphire/result';
import { Survey, SurveyKind } from '@ps/survey-utils';

import { ChildSwitchContext } from './child-switch.context';
import {
  ChildSwitchValidation,
  ChildSwitchViolation,
  feotAgainstQuota,
  manualProcessingSettled,
  respondentStatusSelected,
  uniqueLinksUploaded,
} from './child-switch.rules';

const MC_TRADITIONAL_VALIDATIONS: readonly ChildSwitchValidation[] = [
  manualProcessingSettled,
  respondentStatusSelected,
  uniqueLinksUploaded,
  feotAgainstQuota,
];
const MC_TRADITIONAL_ADD_VALIDATIONS: readonly ChildSwitchValidation[] = [
  manualProcessingSettled,
];
const NO_VALIDATIONS: readonly ChildSwitchValidation[] = [];

export function validateChildSwitch(
  survey: Option<Survey>,
  context: ChildSwitchContext,
): Result<void, ChildSwitchViolation> {
  return survey.match({
    some: (openSurvey) =>
      runValidations(
        validationsFor(openSurvey, MC_TRADITIONAL_VALIDATIONS),
        context,
      ),
    none: () => Result.ok(),
  });
}

export function validateLocaleAdd(
  survey: Option<Survey>,
  context: ChildSwitchContext,
): Result<void, ChildSwitchViolation> {
  return survey.match({
    some: (openSurvey) =>
      runValidations(
        validationsFor(openSurvey, MC_TRADITIONAL_ADD_VALIDATIONS),
        context,
      ),
    none: () => Result.ok(),
  });
}

function runValidations(
  validations: readonly ChildSwitchValidation[],
  context: ChildSwitchContext,
): Result<void, ChildSwitchViolation> {
  return validations.reduce<Result<void, ChildSwitchViolation>>(
    (outcome, validate) => (outcome.isErr() ? outcome : validate(context)),
    Result.ok(),
  );
}

function validationsFor(
  survey: Survey,
  validations: readonly ChildSwitchValidation[],
): readonly ChildSwitchValidation[] {
  return SurveyKind.isTraditionalMc(survey) ? validations : NO_VALIDATIONS;
}
